import { Callback } from '../../models/callback';

/* eslint-disable @typescript-eslint/no-namespace */
export namespace ConfigAction {
  export class Init {
    static readonly type = '[Config] Init';
    constructor(public callback: Callback = null) {}
  }

  export class DismissRelease {
    static readonly type = '[Config] Dismiss Release';
    constructor() {}
  }
}
